import {CHANGE_LANG} from "./actions/ActionTypes";

export const initLanguageState = () => {
	return {
		lang: "it",
	}
};

export const LANGUAGE_INITIAL_STATE = {};

export const LanguageReducer = (state = LANGUAGE_INITIAL_STATE, action) => {
	console.log(action);
	switch (action.type) {
		case CHANGE_LANG:
			return {
				...state,
				lang: action.payload,
			}
		
		default:
			return state;
	}
}